import styled from "styled-components";

export const SOnboardingTourCardPopupButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 20px 20px 20px;
`;
